export default "__VITE_PUBLIC_ASSET__a57a90f2__"